import React, { useEffect } from 'react';
import { ToorakRoadMap } from './components/ToorakRoadMap';
export function App() {
  useEffect(() => {
    // Google Analytics GA4
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-N48MJ5BXHP';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-N48MJ5BXHP');
    `;
    document.head.appendChild(inlineScript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);
  return <div className="min-h-screen bg-white selection:bg-black selection:text-white overflow-x-hidden" data-id="element-0" data-mp="28ufpyg1ohml6">
      {/* Navigation - Transparent & Seamless */}
      <nav className="absolute top-0 w-full z-50 px-6 md:px-12 pt-[calc(1.5rem+env(safe-area-inset-top))] pb-6 flex justify-between items-center gap-4" data-id="element-1" data-mp="23ujl6el5pr4k">
        <span className="font-body text-base md:text-lg text-brand-navy tracking-tight font-medium whitespace-nowrap" data-id="element-2" data-mp="3mlavl1vse5rc">
          BigginScott
          <span aria-hidden="true" className="inline-block align-top w-0 h-0 ml-0.5 border-t-[5px] border-t-brand-mid border-l-[5px] border-l-transparent" data-id="element-3" data-mp="3rdkg22e4udm8"></span>
        </span>
        <button className="border border-brand-navy text-brand-navy bg-white/70 backdrop-blur-sm px-4 md:px-5 py-3 min-h-[44px] font-body text-[10px] tracking-widest uppercase whitespace-nowrap hover:bg-brand-navy hover:text-white active:bg-brand-navy active:text-white transition-colors duration-300 flex items-center justify-center" data-id="element-4" data-mp="2zmo5x9jgin2n">
          Enquire Now
        </button>
      </nav>

      {/* Hero Section */}
      <section className="relative h-[100svh] w-full overflow-hidden bg-white" data-id="element-5" data-mp="nxn6nvnsp9oy">
        {/* Top Left Label */}
        <div className="absolute top-[calc(6.5rem+env(safe-area-inset-top))] left-0 z-20 flex items-stretch" data-id="element-6" data-mp="swgmvvugvest">
          <p className="font-body text-[9px] md:text-[10px] text-white tracking-widest uppercase bg-brand-navy pl-6 md:pl-12 pr-5 md:pr-6 py-3" data-id="element-7" data-mp="3uct3bjmdin0h">
            Exclusive Off-Market Offering
          </p>
          {/* Red cap — echoes the triangle in the wordmark */}
          <span aria-hidden="true" className="w-1 bg-brand-mid" data-id="element-8" data-mp="86cmj86mvdl8"></span>
        </div>

        {/* Video Background */}
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-90" data-id="element-9" data-mp="3gj1ru5p30t24">
          <source src="https://cdn.magicpatterns.com/uploads/8BaiNeZsUH4k6kuiiPfgMA/VL_Example_Visual.mp4" type="video/mp4" data-id="element-10" data-mp="3qcr37ewae1nb" />
        </video>

        {/* Seamless Light Gradient Overlay for text legibility at the bottom */}
        <div className="absolute inset-0 seamless-fade z-10" data-id="element-11" data-mp="2swbu3gjrnknb"></div>

        {/* Bottom Content - Smaller Text */}
        <div className="absolute bottom-[calc(2.5rem+env(safe-area-inset-bottom))] md:bottom-[calc(3rem+env(safe-area-inset-bottom))] inset-x-0 px-6 md:px-12 z-20" data-id="element-12" data-mp="18cq6dlx04itg">
          <div className="max-w-7xl mx-auto flex flex-col items-start" data-id="element-13" data-mp="yflfj8s7nz6b">
            <p className="font-body text-[10px] text-brand-navy tracking-widest uppercase mb-3 md:mb-4" data-id="element-14" data-mp="ydija70gt9t5">
              Toorak, Victoria
            </p>
            <h1 className="font-display font-normal text-[2.75rem] sm:text-5xl md:text-6xl lg:text-7xl text-black leading-[1.05] mb-5 md:mb-8" data-id="element-15" data-mp="1r3zi81u8vjo7">
              78 Hopetoun <br data-id="element-16" data-mp="1w0zmc77jacco" />
              <span className="italic text-brand-navy" data-id="element-17" data-mp="1i3ujsh713vm6">Avenue.</span>
            </h1>

            <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-end gap-6 md:gap-8 border-t border-black/10 pt-6 md:pt-8" data-id="element-18" data-mp="1m56364zb7klx">
              <p className="font-body font-light text-gray-dark text-sm md:text-base max-w-md leading-relaxed" data-id="element-19" data-mp="6muiwx6m88gj">
                A masterclass in architectural elegance. Offered privately to a
                select portfolio of qualified buyers.
              </p>

              {/* Scroll Indicator */}
              <div className="hidden md:flex flex-col items-center gap-3" data-id="element-20" data-mp="m4uj53b8dglm">
                <span className="font-body text-[10px] text-black tracking-widest uppercase" data-id="element-21" data-mp="h8dtu5saow6y">
                  Discover
                </span>
                <div className="w-[1px] h-12 bg-black/10 relative overflow-hidden" data-id="element-22" data-mp="c66dz54cgvzc">
                  <div className="absolute top-0 left-0 w-full h-full bg-black animate-[scroll_2s_ease-in-out_infinite]" data-id="element-23" data-mp="19v8a0qi2x9em"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Details Strip */}
      <section className="bg-white border-b border-black/5 relative z-20" data-id="element-24" data-mp="vx059wesx3sw">
        <div className="grid grid-cols-2 md:grid-cols-4" data-id="element-25" data-mp="3knt14z9agroe">
          {[{
          value: '5',
          label: 'Bedrooms'
        }, {
          value: '4',
          label: 'Bathrooms'
        }, {
          value: '1,240',
          label: 'SQM Land'
        }, {
          value: 'Private',
          label: 'Sale Status'
        }].map((stat, i) => <div key={i} className={`py-10 md:py-12 px-4 md:px-6 flex flex-col items-center justify-center text-center ${i !== 3 ? 'md:border-r border-black/5' : ''} ${i % 2 === 0 ? 'border-r border-black/5' : ''} ${i < 2 ? 'border-b border-black/5 md:border-b-0' : ''}`} data-id="element-26" data-mp="2530iq9rnqajm" data-mpi={i}>
              <span className="font-display text-3xl md:text-4xl text-brand-navy mb-2 md:mb-3" data-id="element-27" data-mp="2nvl7bf0bpthm">
                {stat.value}
              </span>
              <span className="font-body text-[10px] text-gray-muted tracking-widest uppercase" data-id="element-28" data-mp="2stmpzytu7qsk">
                {stat.label}
              </span>
            </div>)}
        </div>
      </section>

      {/* Property Description */}
      <section className="bg-offWhite py-16 md:py-32 px-6 md:px-12" data-id="element-29" data-mp="yir8g70od1dn">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-24" data-id="element-30" data-mp="21sdhwbwls5kx">
          <div className="md:col-span-5" data-id="element-31" data-mp="1wtsnit418g4e">
            <div className="flex items-center gap-4 mb-6 md:mb-8" data-id="element-32" data-mp="1wutxsvd84yl2">
              <div className="w-8 h-[1px] bg-brand-navy" data-id="element-33" data-mp="2attmu44nffhr"></div>
              <span className="font-body text-[10px] text-brand-navy tracking-widest uppercase" data-id="element-34" data-mp="25sw8k2mrf5lj">
                The Vision
              </span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-black leading-[1.1]" data-id="element-35" data-mp="2ko3jvz4jd1yt">
              The <br data-id="element-36" data-mp="2fp8yqqj3j1bj" />
              <span className="italic text-brand-navy" data-id="element-37" data-mp="2tii7coz7zit0">Residence.</span>
            </h2>
          </div>
          <div className="md:col-span-7 flex items-center" data-id="element-38" data-mp="2phetg80qfwuf">
            <p className="font-body font-light text-gray-dark text-base md:text-lg leading-[1.8] md:leading-[2] md:pl-12 md:border-l border-black/10" data-id="element-39" data-mp="2phy8ngz0074r">
              Set on one of Toorak's most coveted tree-lined streets, this
              exceptional family home is a rare offering of space, light, and
              craftsmanship. Positioned on a north-facing 1,240sqm allotment,
              the residence unfolds across two generous levels — with a seamless
              connection between indoors and out, resort-style entertaining, and
              interiors finished to an exacting standard.
            </p>
          </div>
        </div>
      </section>

      {/* Key Highlights */}
      <section className="features-wash py-16 md:py-32 px-6 md:px-12" data-id="element-40" data-mp="2zbk94v5peink">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-24" data-id="element-41" data-mp="344wzpaty0ziy">
          <div className="md:col-span-5" data-id="element-42" data-mp="2pfqsp0ov650i">
            <div className="md:sticky md:top-32" data-id="element-43" data-mp="2pcust6tgh69f">
              <div className="flex items-center gap-4 mb-6 md:mb-8" data-id="element-44" data-mp="2ud93kwmfyub5">
                <div className="w-8 h-[1px] bg-brand-navy" data-id="element-45" data-mp="2ge9c7h7jo1ba"></div>
                <span className="font-body text-[10px] text-brand-navy tracking-widest uppercase" data-id="element-46" data-mp="2gf2oexp9vj0t">
                  The Detail
                </span>
              </div>
              <h2 className="font-display text-4xl md:text-5xl text-black leading-[1.1]" data-id="element-47" data-mp="30uc7u1qoo6la">
                Curated <br data-id="element-48" data-mp="2vxc25rxqx5up" />
                <span className="italic text-brand-navy" data-id="element-49" data-mp="2vwtv009jp780">Features.</span>
              </h2>
            </div>
          </div>
          <div className="md:col-span-7" data-id="element-50" data-mp="2qzagcz8xqsfj">
            <ul className="flex flex-col border-t border-brand-navy/15" data-id="element-51" data-mp="2lywa9mqw9sk5">
              {['Five bedrooms including master retreat with walk-in robe and ensuite', 'Four bathrooms, study, and powder room', 'Heated pool and spa with north-facing garden and entertaining terrace', 'Gourmet kitchen with stone benchtops and full Miele appliance suite', 'Separate dining, formal sitting, and casual living zones', 'Triple garage with internal access and storage', '1,240sqm north-facing allotment — a rarity at this address', 'Walking distance to Toorak Village, Fawkner Park, and elite private schools'].map((item, i) => <li key={i} className="py-5 md:py-6 border-b border-brand-navy/15 last:border-0 flex flex-row items-start md:items-center gap-4 md:gap-8 group" data-id="element-52" data-mp="9r8y0u47er1p" data-mpi={i}>
                  <span className="font-display italic text-xl md:text-2xl text-brand-navy/40 group-hover:text-brand-navy transition-colors duration-300 mt-0.5 md:mt-0" data-id="element-53" data-mp="nof9e3mllngw">
                    0{i + 1}
                  </span>
                  <span className="font-body font-light text-gray-dark text-sm md:text-base leading-relaxed group-hover:text-black transition-colors duration-300" data-id="element-54" data-mp="3r4mbw6ta1eo3">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="bg-offWhite py-16 md:py-32 px-6 md:px-12" data-id="element-55" data-mp="33fjosjfvitm7">
        <div className="max-w-7xl mx-auto" data-id="element-56" data-mp="38duy8t29b23w">
          <div className="flex items-center justify-center gap-4 mb-10 md:mb-16" data-id="element-57" data-mp="38cju2s4wfsc9">
            <div className="w-8 h-[1px] bg-brand-navy" data-id="element-58" data-mp="2f6vi386l1q6c"></div>
            <span className="font-body text-[10px] text-brand-navy tracking-widest uppercase" data-id="element-59" data-mp="2k5f418l6f1yp">
              Visuals
            </span>
            <div className="w-8 h-[1px] bg-brand-navy" data-id="element-60" data-mp="2p62rxle3z2op"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-61" data-mp="2u330q42cejji">
            {[1, 2, 3].map(num => <button key={num} type="button" aria-label={`View property image ${num}`} className="group relative overflow-hidden w-full focus:outline-none focus-visible:ring-1 focus-visible:ring-black focus-visible:ring-offset-2" data-id="element-62" data-mp="1wej5ztq4naj0">
                <div className="aspect-[4/3] md:aspect-[4/5] w-full bg-gray-light border border-black/5 transition-transform duration-300 ease-out md:group-hover:scale-105" data-id="element-63" data-mp="2b7cz4hybnp65"></div>
                <div className="absolute inset-0 bg-white/40 md:bg-white/60 opacity-100 md:opacity-0 md:group-hover:opacity-100 md:group-focus-visible:opacity-100 transition-opacity duration-300 ease-out flex items-center justify-center" data-id="element-64" data-mp="1inefbh4qlskt">
                  <span className="font-body text-[10px] text-black tracking-widest uppercase border border-black bg-white/70 md:bg-transparent px-5 py-3 min-h-[44px] flex items-center justify-center" data-id="element-65" data-mp="3mykedi57hq5a">
                    View Image
                  </span>
                </div>
              </button>)}
          </div>
          <p className="font-body text-[10px] text-gray-muted tracking-widest uppercase text-center max-w-2xl mx-auto leading-loose" data-id="element-66" data-mp="388v50zmymftx">
            Full photography, floor plan and property memorandum available upon
            approved enquiry.
          </p>
        </div>
      </section>

      {/* Location */}
      <ToorakRoadMap data-id="element-67" data-mp="2u9n5g5mvx5p7" />

      {/* Agent Section */}
      <section className="bg-offWhite py-16 md:py-32 px-6 md:px-12" data-id="element-68" data-mp="2pbbvzw0i4x7i">
        <div className="max-w-7xl mx-auto" data-id="element-69" data-mp="2pd52nbb47hfi">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-24 items-center" data-id="element-70" data-mp="2fn6lk3g54bxp">
            <div className="md:col-span-5 relative" data-id="element-71" data-mp="2kn2e96je0gxy">
              <div className="aspect-[3/4] w-full max-w-[280px] md:max-w-sm mx-auto bg-gray-light border border-brand-navy/15 relative z-10" data-id="element-72" data-mp="2knu7iapii2l2">
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-73" data-mp="2antmmkbzveer">
                  <span className="font-body text-[10px] text-gray-muted tracking-widest uppercase" data-id="element-74" data-mp="2ydxtr1oe5wai">
                    Agent Portrait
                  </span>
                </div>
              </div>
              {/* Decorative editorial frame */}
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-12 w-full max-w-[280px] md:max-w-sm h-full border border-brand-navy/25 z-0 hidden md:block" data-id="element-75" data-mp="2pkudklmd35c6"></div>
            </div>

            <div className="md:col-span-7 flex flex-col text-center md:text-left" data-id="element-76" data-mp="3hc0bcvem0qya">
              <div className="flex items-center justify-center md:justify-start gap-4 mb-4 md:mb-6" data-id="element-77" data-mp="3m4jyaiz6syfr">
                <div className="w-8 h-[1px] bg-brand-navy" data-id="element-78" data-mp="1anhtbk5bahvg"></div>
                <span className="font-body text-[10px] text-brand-navy tracking-widest uppercase block" data-id="element-79" data-mp="15pq10p0r8tqq">
                  Exclusive Representation
                </span>
              </div>
              <h3 className="font-display text-4xl md:text-5xl text-black mb-2 md:mb-3" data-id="element-80" data-mp="1ff9k9vsdqpm4">
                Director
              </h3>
              <p className="font-body text-lg md:text-xl text-brand-navy font-medium tracking-tight mb-6 md:mb-8" data-id="element-81" data-mp="rovsm6dpiss2">
                BigginScott
                <span aria-hidden="true" className="inline-block align-top w-0 h-0 ml-0.5 border-t-[6px] border-t-brand-mid border-l-[6px] border-l-transparent" data-id="element-82" data-mp="msouv0vgsnl7"></span>
              </p>

              <div className="flex flex-col border-y border-brand-navy/15 divide-y divide-brand-navy/15" data-id="element-83" data-mp="2d2icsaqssyxm">
                <a href="tel:04XXXXXXX" className="group flex items-center justify-between gap-6 py-4 min-h-[56px]" data-id="element-84" data-mp="284glx3n4rvbl">
                  <span className="font-body text-[10px] tracking-widest uppercase text-brand-navy/60" data-id="element-85" data-mp="mlwkl0dufeko">
                    Phone
                  </span>
                  <span className="font-body font-light text-sm md:text-base text-brand-navy group-hover:text-brand-mid transition-colors duration-300" data-id="element-86" data-mp="qmqau0erd5gq">
                    04XX XXX XXX
                  </span>
                </a>
                <a href="mailto:agent@bigginscott.com.au" className="group flex items-center justify-between gap-6 py-4 min-h-[56px]" data-id="element-87" data-mp="10jl341kfu9mk">
                  <span className="font-body text-[10px] tracking-widest uppercase text-brand-navy/60" data-id="element-88" data-mp="1acacmqwfhdf9">
                    Email
                  </span>
                  <span className="font-body font-light text-sm md:text-base text-brand-navy group-hover:text-brand-mid transition-colors duration-300 break-all text-right" data-id="element-89" data-mp="1jcyjn1nemdin">
                    agent@bigginscott.com.au
                  </span>
                </a>
              </div>

              <p className="font-body font-light text-sm text-gray-dark/80 mt-6 md:mt-8 leading-relaxed text-center md:text-left" data-id="element-90" data-mp="1tgdo1pfyh647">
                For a private inspection or further information, contact us
                directly.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-brand-navy pt-14 md:pt-20 pb-12 md:pb-16 px-6 md:px-12" data-id="element-91" data-mp="2h4dawea5ccdi">
        <div className="max-w-7xl mx-auto" data-id="element-92" data-mp="2c6buk143ur5q">
          {/* Brand row */}
          <div className="flex flex-col items-center gap-4 md:flex-row md:items-center md:justify-between md:gap-8 pb-8 md:pb-10 border-b border-white/10" data-id="element-93" data-mp="27fn0qf4ydi3f">
            <span className="font-body text-xl md:text-2xl text-white tracking-tight font-medium" data-id="element-94" data-mp="23e1g27m6fzio">
              BigginScott
              <span aria-hidden="true" className="inline-block align-top w-0 h-0 ml-1 border-t-[7px] border-t-brand-mid border-l-[7px] border-l-transparent" data-id="element-95" data-mp="2zy0mvhgxffmo"></span>
            </span>
            <p className="font-display italic text-base md:text-lg text-white/90 text-center md:text-right" data-id="element-96" data-mp="y7ju58vne23r">
              At The Heart Of Where You Live
            </p>
          </div>

          {/* Fine print row */}
          <div className="flex flex-col items-center gap-5 md:flex-row md:items-center md:justify-between md:gap-8 pt-7 md:pt-8" data-id="element-97" data-mp="og5o0i96y41n">
            <p className="font-body font-light text-xs text-white/50 max-w-md leading-relaxed text-center md:text-left" data-id="element-98" data-mp="ajiny6lxyxri">
              This property is being offered prior to public listing. All
              enquiries are strictly confidential.
            </p>
            <p className="font-body text-[10px] text-white/35 tracking-widest uppercase whitespace-nowrap" data-id="element-99" data-mp="5je5wc5dxuz6">
              © 2026 BigginScott
            </p>
          </div>
        </div>
      </footer>

      {/* VAULT[LAB] CTA Footer */}
      <section className="bg-black text-white pt-20 md:pt-28 pb-[calc(5rem+env(safe-area-inset-bottom))] md:pb-[calc(7rem+env(safe-area-inset-bottom))] px-6 md:px-12" data-id="element-100" data-mp="1zu9psam0swh9">
        <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-101" data-mp="3fgmrftkina4l">
          {/* Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/aWu5gR31tYCFJYZoPQxy5u/EMAIL_SIG_LITE.png" alt="VAULT[LAB]" className="w-full max-w-xs md:max-w-sm mb-10 md:mb-12" data-id="element-102" data-mp="3u4zn0pfoyqyk" />

          {/* Pitch line */}
          <p className="font-body font-light text-base md:text-xl text-white max-w-3xl leading-relaxed mb-10 md:mb-14" data-id="element-103" data-mp="2y6qhyvufg0d">
            If one of your listings came to mind while you were reading this —
            <br className="hidden md:block" data-id="element-104" data-mp="byusfv7yppww" />
            that's the one.
          </p>

          {/* CTA */}
          <a href="mailto:elliott@vaultlab.agency" className="group inline-flex items-center gap-4 bg-[#C8FF00] text-black px-7 md:px-8 py-5 min-h-[56px] font-body text-[11px] md:text-xs tracking-[0.2em] md:tracking-[0.25em] uppercase font-semibold whitespace-nowrap hover:bg-white active:bg-white transition-colors duration-300 ease-out" data-id="element-105" data-mp="2ioj58pgnzy8j">
            Get In Touch
            <span className="w-6 h-[1px] bg-black group-hover:w-10 transition-[width] duration-300 ease-out" data-id="element-106" data-mp="21m2arpu5cv64"></span>
          </a>
        </div>
      </section>

      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes scroll {
            0% { transform: translateY(-100%); }
            50% { transform: translateY(0); }
            100% { transform: translateY(100%); }
          }
        `
    }} data-id="element-107" data-mp="26nrlf4dgj6to" />
    </div>;
}